import React from 'react';
import CheckinProgressBar from './CheckinProgressBar';
import { useCheckinProgress } from '../hooks/useCheckinProgress';

export interface CheckinLayoutProps {
  title?: string;
  subtitle?: string;
  showProgress?: boolean;
  children: React.ReactNode;
}

// Workflow reconciliation is the responsibility of each page's save handler
// (which awaits refreshWorkflow() after saving and before navigating). The
// initial page-load fetch is handled by WorkflowProvider's `!workflow`
// guarded effect. Mounting CheckinLayout no longer triggers a workflow
// refetch — that would duplicate the explicit save-refresh on every Continue
// click.
const CheckinLayout: React.FC<CheckinLayoutProps> = ({
  title,
  subtitle,
  showProgress = true,
  children,
}) => {
  const progress = useCheckinProgress();

  return (
    <div className="min-h-screen bg-[#F7F8FD] flex flex-col">
      <div className="flex flex-row px-10 py-6 shadow justify-between bg-white items-center">
        <span className="text-[#01545D] font-semibold text-2xl">
          Axis Integrated Mental Health
        </span>
        <span className="text-[#01545D] font-medium text-xl">Patient Check-In</span>
      </div>
      <main className="flex-grow container mx-auto flex flex-col items-center px-4 py-10">
        {showProgress && (
          <CheckinProgressBar
            percent={progress.percent}
            currentIndex={progress.currentIndex}
            total={progress.total}
          />
        )}
        {title && (
          <h1 className="text-3xl font-semibold text-[#01545D] text-center mt-2">{title}</h1>
        )}
        {subtitle && (
          <p className="text-base text-[#5D6A85] text-center mt-2 max-w-[700px]">{subtitle}</p>
        )}
        {children}
      </main>
    </div>
  );
};

export default CheckinLayout;
